import { removeExtensibilityFrameworkComponent } from 'owa-addins-view';
import { onModuleClick } from 'owa-left-rail-utils';
import { createLazyOrchestrator } from 'owa-bundling';

export const moduleChangeOrchestrator = createLazyOrchestrator(
    onModuleClick,
    'clone_moduleChange',
    actionMessage => {
        removeExtensibilityFrameworkComponent(window, true /*isModuleChanged*/);
    }
);
